<template>

   
    <div class="container mt-2 justify-content-center">
     <div class="row ">
   
             <div class="col-12 mt-3">

                 <table class="table">
   <thead>
     <tr>
       <th scope="col">#</th>
       <th scope="col">მოდული</th>
       <th scope="col">ლექტორი</th>
       <th scope="col">დაწყება</th>
       <th scope="col">დასრულება </th>
       <th scope="col">

        <button type="button" class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
    შეტყობინების გაგზავნა ჯგუფებთან
</button>

<!-- Modal -->
<div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
       
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="mb-3">
  
  <input type="text" class="form-control" id="exampleFormControlInput1" placeholder="თემა">
</div>
        <Editor
      api-key="no-api-key"
      :init="{
        plugins: 'lists link image table code help wordcount'
      }"
    />

      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-success">გაგზავნა</button>
      </div>
      
    </div>
  </div>
</div>

       </th>
 
     </tr>
   </thead>
   <tbody>
     
    <tr>
       <th scope="row">1</th>
       <td>Mark</td>
       <td>Otto</td>
       <td>@mdo</td>
       <td>Otto</td>
        <td> 
<!-- Button trigger modal -->
<button type="button" class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
    შეტყობინების გაგზავნა
</button>

<!-- Modal -->
<div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
       
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="mb-3">
  
  <input type="text" class="form-control" id="exampleFormControlInput1" placeholder="თემა">
</div>
        <Editor
      api-key="no-api-key"
      :init="{
        plugins: 'lists link image table code help wordcount'
      }"
    />

      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-success">გაგზავნა</button>
      </div>
      
    </div>
  </div>
</div>

       
       </td>
     </tr>
     <tr>
       <th scope="row">2</th>
       <td>Mark</td>
       <td>Otto</td>
       <td>@mdo</td>
       <td>Otto</td>
       <td> 
<!-- Button trigger modal -->
<button type="button" class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
    შეტყობინების გაგზავნა
</button>

<!-- Modal -->
<div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
       
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="mb-3">
  
  <input type="text" class="form-control" id="exampleFormControlInput1" placeholder="თემა">
</div>
        <Editor
      api-key="no-api-key"
      :init="{
        plugins: 'lists link image table code help wordcount'
      }"
    />

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-success">გაგზავნა</button>
      </div>
      
    </div>
  </div>
</div>

       </td>
     </tr>
     <tr>
       <th scope="row">3</th>
       <td>Mark</td>
       <td>Otto</td>
       <td>@mdo</td>
       <td>Otto</td>
       <td> 
<!-- Button trigger modal -->
<button type="button" class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
 შეტყობინების გაგზავნა
</button>

<!-- Modal -->
<div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
       
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">

        <div class="mb-3">
  
  <input type="text" class="form-control" id="exampleFormControlInput1" placeholder="თემა">
</div>
        <Editor
      api-key="no-api-key"
      :init="{
        plugins: 'lists link image table code help wordcount'
      }"
    />

    
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-success">გაგზავნა</button>
      </div>
      
    </div>
  </div>
</div>

       </td>
     </tr>
  
   
 
   </tbody>
 </table>
             </div>
 
     </div>
    </div>
  

 </template>

 <script>
import Editor from '@tinymce/tinymce-vue'

export default{

components:{
     Editor 


}


}
 

</script>

